function initFilterBar() {
  document.querySelectorAll("[data-filter-bar]").forEach((bar) => {
    const toggle = bar.querySelector(".filter-bar__toggle");
    if (!toggle) {
      return;
    }

    toggle.addEventListener("click", () => {
      const open = bar.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFilterBar);
} else {
  initFilterBar();
}
